import { defineMessages } from 'react-intl';

export default defineMessages({
    ErrorTitle: {
        id: 'cep.errorPage.ErrorTitle',
        defaultMessage: 'Please contact us'
    },
    SorryIssueHasOccurred: {
        id: 'cep.errorPage.SorryIssueHasOccurred',
        defaultMessage: 'Sorry, an issue has occurred which prevents us from proceeding further.'
    },
    ContactUs: {
        id: 'cep.errorPage.ContactUs',
        defaultMessage: 'We are here to help, online or over the phone.'
    },
    BackToHome: {
        id: 'cep.errorPage.BackToHome',
        defaultMessage: 'Back to Home'
    },
    LeaveMessage: {
        id: 'cep.errorPage.LeaveMessage',
        defaultMessage: 'Leave a message'
    },
    ChatOnline: {
        id: 'cep.errorPage.ChatOnline',
        defaultMessage: 'Chat online'
    },
});
